import { FloatingArrow, type FloatingArrowProps } from '@floating-ui/react';
import { clsx } from 'clsx';
import { forwardRef } from 'react';

interface Props extends Pick<FloatingArrowProps, 'context'> {
  variant: 'light' | 'dark';
  className?: string;
}

const variantClasses = {
  light: clsx(
    '!bottom-[98%] -translate-y-3 fill-main [&>path:first-of-type]:stroke-decorative',
  ),
  dark: clsx('fill-strong'),
};

const Arrow = forwardRef<SVGSVGElement, Props>(
  ({ context, variant, className }, ref) => (
    <FloatingArrow
      context={context}
      ref={ref}
      width={18}
      height={9}
      tipRadius={3}
      strokeWidth={variant === 'light' ? 3 : 0}
      className={clsx(variantClasses[variant], className)}
    />
  ),
);

Arrow.displayName = 'Arrow';

export default Arrow;
